// extracted by mini-css-extract-plugin
module.exports = {"InactiveScoringGridContainer":"InactiveScoringGridContainer_InactiveScoringGridContainer__3AmEm","Icon":"InactiveScoringGridContainer_Icon__3SJyJ"};